import { useInitialRender } from "@/hooks/useInitialRender"

export const isDataAvailable = (
  context: ReturnType<typeof useInitialRender>,
  props?: { isLoading?: boolean }
): boolean => {
  const { isLoading, response } = context
  const { metadata } = response || {}
  const loading = isLoading || props?.isLoading

  return !loading && !!metadata && metadata.total > 0
}

export const noDataAvailable = (
  context: ReturnType<typeof useInitialRender>,
  props?: { isLoading?: boolean }
): boolean => {
  if (context.isLoading || props?.isLoading) return false

  return isDataAvailable(context, props) === false
}
